import { formatTimeAgo, type Column } from '@platform/design-system';
import type { Order } from '../orders/orders.ts';
import { usePageContext } from '../usePageContext.ts';
import { ParcelWorklist, type ParcelWorklistProps } from './ParcelWorklist.tsx';

export type MissingParcelsPageProps = Omit<
  ParcelWorklistProps,
  'kind' | 'view' | 'statusFilter' | 'timingColumn' | 'action'
>;

export const MissingParcelsPage = (props: MissingParcelsPageProps) => {
  const { t, locale } = usePageContext();
  const now = new Date();
  const createdSince: Column<Order> = {
    id: 'createdSince',
    header: t('parcels.createdSince'),
    cell: (order) => formatTimeAgo(order.createdAt, locale, now),
  };
  return (
    <ParcelWorklist
      {...props}
      kind="missing"
      view="missing"
      statusFilter={null}
      timingColumn={createdSince}
    />
  );
};
